import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { app } from "../../../Frame/App";
import { DesignParser } from "./Util/DesignParser";
import { WidgetMeasureTree, MarkupMeasureTreeModel, MeasureTreeTypeEnum, WidgetMeasureTreeModel, optionsMeasureTreeModel } from "../Widgets/WidgetMeasureTree";
import { MeasureTextProvider } from "./Util/MeasureTextProvider";
import { group, Console } from "console";
import { MeasureEditFactory } from "../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../../PagePopup";
import { Script } from "vm";
import { FixedDialog } from "../../FixedDialog";

export type WidgetMeasureTreeComponentProps = {
    widget: WidgetMeasureTree;
    clientId: string;
    measureId: number;
    markup: MarkupMeasureTreeModel[];
    styles: string;
    json: string;
    templateId: string;
    viewId: number;
    templateOptions: optionsMeasureTreeModel[];
}

export class WidgetMeasureTreeComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetMeasureTreeComponentProps;
    markup: MarkupMeasureTreeModel[];
    options:optionsMeasureTreeModel[];
    jsonData: any;

    /*private promises: { [id: string]: any } = {};*/

    constructor(props: WidgetMeasureTreeComponentProps) {
        super(props);
        this.markup = this.props.markup;

        this.options = this.props.templateOptions;
        if (!this.options) { this.options = []; }

        try {
            if (this.props.json) { this.jsonData = JSON.parse(this.props.json);}
        } catch (err) {
            console.log(`Could not parse json: ${this.props.json}`);
        }
    }

    element: HTMLElement;
    getElement = () => {
        this.element = <div className={`widget Background-Blur-90-MSO px-3 py-3  m-b-c ${this.props.clientId}`} style={{ "height": "100%", "overflow-y":"auto"}}>
        </div>;
    }

    

    private parseDesign = (markup: string, measureId: number, childViewId: number = 0) => {
        let measureItemElement: HTMLElement = this.element.querySelector(`.measure-item[data-id="${measureId}"]`);
        if (measureItemElement) {
            var processedMarkup = DesignParser.processDeferredElements(markup);
            DesignParser.parseDesign(measureItemElement, processedMarkup.markup);
            DesignParser.appendStyles(this.props.clientId, this.props.styles);
            DesignParser.executeDomFunctions(measureItemElement, null, this.jsonData);
            DesignParser.setLinksFromJson(measureItemElement, this.jsonData);

            for (let item of processedMarkup.deferredElements) {
                item.insert(measureItemElement, this.jsonData);
            }


            // please, use the tag <object> to load svg imgs & use the api 'documents/getSvg/id' to get svg filetype
            // svg elements: change the color of images by change the attribute 'fill' of <path> tag
            // define the desired color within an attrribute 'data-svg-color'
            measureItemElement.querySelectorAll("[data-svg]").forEach(e => {
                let svgObject = (e as HTMLObjectElement)
                let color = svgObject.getAttribute("data-svg-color");
                if (color) {
                    svgObject.onload = function(){
                        let content = svgObject.contentDocument;
                        var svgElement = content?.getElementsByTagName('svg');
                        var myPaths = svgElement[0].children;
                        for (let i = 0; i < myPaths.length; i++) {
                            myPaths[i].setAttribute("fill", color);
                        }
                    }
                }
            });

            // set child viewId for expander elements
            measureItemElement.querySelectorAll("[data-expander]")?.forEach((e) => { (e as HTMLElement).setAttribute("data-view-id", childViewId.toString()) });
            DesignParser.createExpanderEvent(measureItemElement, this.renderData);

            // Edit a measure: Look for an element which has attribute "data-edit"
            // else assign the edit event to whole row "m-header"
            let editElement: HTMLDivElement = measureItemElement.querySelector("[data-edit]");
            if (editElement) {
                editElement.classList.add("pointer");
                editElement.addEventListener("click", this.onMeasureClick);
            } else {
                let headerElement: HTMLDivElement = measureItemElement.querySelector(".m-header");
                if (headerElement) {
                    headerElement.classList.add("pointer");
                    headerElement.addEventListener("click", this.onMeasureClick);
                }
            }
            DesignParser.createUserPositionStorage(measureItemElement);
        }
    }

    // Add button "new measure" to desired template
    private renderButton(container: HTMLElement, templateId: number = 0, measureId: number = 0) {
        // get button design from the current markup of the template, which is defined by an element has as attribute 'data-button-invisible'
        // get the first child of this invisible element and append it to measures container
        // then remove all the elements with 'data-button-invisible' attribute
        let buttonMarkup = container.querySelector("[data-button-invisible]");
        if (buttonMarkup) {
            let buttonNewElement = buttonMarkup.firstElementChild;
            DesignParser.newMeasureLinks(buttonNewElement as HTMLElement);
            container.appendChild(buttonNewElement);

            container.querySelectorAll("[data-button-invisible]")?.forEach(e => e.remove());
        } else {
            // when no template measure is defined, and template has the option of "button new"
            // we get the design button from the template markup
            if (templateId != 0) {
                let markup = this.markup.find(f => f.templateId == templateId) ? this.markup.find(f => f.templateId == templateId).markup : "";
                if (markup != "") {
                    // check if we have placeholder for measureParent
                    let placeholders = MeasureTextProvider.getPlaceHolders(markup);
                    if (placeholders.find(f => f == "measure:ParentId")) {
                        markup = MeasureTextProvider.replace(markup, "measure:ParentId", measureId.toString())
                    }
                    markup = MeasureTextProvider.replaceLocalizedStrings(markup, this.jsonData);

                    var processedMarkup = DesignParser.processDeferredElements(markup);
                    let div = document.createElement("div");

                    div.innerHTML = processedMarkup.markup;
                    for (let item of processedMarkup.deferredElements) {
                        item.insert(div, this.jsonData);
                    }

                    let buttonMarkup = div.querySelector("[data-button-invisible]");
                    if (buttonMarkup) {
                        let buttonNewElement = buttonMarkup.firstElementChild;
                        DesignParser.newMeasureLinks(buttonNewElement as HTMLElement);
                        container.appendChild(buttonNewElement);
                    }
                }
            }
        }
    }

    // parse widget with data
    private renderData = (container: HTMLElement, measureId: number, viewId: number) => {
        if (viewId == 0 || isNaN(viewId) || app.isNullOrUndefined(viewId)) {
            console.log("Error: Invalid value of viewId - " + viewId);
        }
        else {
            let viewData = {
                defaultFilter: null,
                parentId: measureId,
                singleId: "0",
                singleTemplateId: 0,
                view: "Massnahmenliste",
                viewId: viewId,
                viewIndex: 0,
            }

            $.ajax({
                url: app.resolveUrl("~/api/tableView/getMeasureTree"),
                method: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(viewData),
                async: false,
                success: (view) => {
                    if (view.data && view.data.length > 0) {
                        let groups: { templateId: number, measureIds: number[] }[] = [];
                        let childViewId: number = 0;
                        if (view.columns && view.columns[0]) {
                            childViewId = view.columns[0].decimals;
                        }
                        for (let row in view.data) {
                            if (this.markup.find(f => f.templateId == view.data[row].EreignisId_Id)) {
                                // group rows by TemplateId
                                this.groupByTemplateId(groups, parseInt(view.data[row].EreignisId_Id), parseInt(view.data[row].Id));

                                // create placeholder-divs in element, that we fill with the html markup and data later on.
                                // only measure which its template is defined in markupList
                                container.appendChild(
                                    <div className="measure-item mb-2" data-id={view.data[row].Id}> </div>
                                );
                            }
                        }

                        let promises = [];
                        for (let group of groups.sort((a, b) => a.templateId > b.templateId ? 1 : -1)) {
                            let markupForTemplateId = this.markup.find(f => f.templateId == group.templateId);

                            if (!app.isNullOrUndefined(markupForTemplateId) && markupForTemplateId.markup != "") {
                                let placeholders = MeasureTextProvider.getPlaceHolders(markupForTemplateId.markup);

                                // uniqueIds model
                                let placeHolderTreeModel = new WidgetMeasureTreeModel();
                                placeHolderTreeModel.measureIds = group.measureIds;
                                placeHolderTreeModel.templateId = markupForTemplateId.templateId;
                                placeHolderTreeModel.uniqueIds = placeholders;

                                promises.push($.ajax({
                                    url: app.resolveUrl(`~/api/measure/getMultipleMeasureValues`),
                                    method: "POST",
                                    contentType: "application/json",
                                    data: JSON.stringify(placeHolderTreeModel),
                                    async: false,
                                    success: (valuesForMeasures) => {
                                        let count = 1;
                                        for (let item in group.measureIds) {
                                            let measureId = group.measureIds[item];
                                            let values = valuesForMeasures[measureId];
                                            if (values) {
                                                let markupForMeasure = MeasureTextProvider.replaceFixedPlaceholders(markupForTemplateId.markup);
                                                markupForMeasure = MeasureTextProvider.replaceLocalizedStrings(markupForMeasure, this.jsonData);
                                                markupForMeasure = MeasureTextProvider.replaceConditionals(markupForMeasure, valuesForMeasures[measureId]);
                                                markupForMeasure = MeasureTextProvider.replaceMeasureTextWithValues(markupForMeasure, placeholders, valuesForMeasures[measureId], count);
                                                // parse design
                                                this.parseDesign(markupForMeasure, measureId, childViewId);
                                                count++;
                                            }
                                        }

                                        // add button 'new' after all measure items are created
                                        if (this.options.find(f => f.templateId == group.templateId && f.hasButtonNew)) {
                                            this.renderButton(container);
                                        }
                                    },
                                    error: (err) => {
                                        console.log(err);
                                    }
                                }));
                            }
                        }

                    }
                    else {
                        // add button 'new' after all measure items are created
                        if (this.options.find(f => f.templateId == view.newMeasureTemplateIds[0] && f.hasButtonNew)) {
                            this.renderButton(container, view.newMeasureTemplateIds[0], measureId);
                        }
                    }
                   
                },
                error: (err) => {
                    console.log(err);
                },
            });
        }
    }

    private onMeasureClick = (ev: MouseEvent) => {
        let measureItem = (ev.target as HTMLElement).closest(".measure-item") as HTMLDivElement;
        let id = measureItem.getAttribute("data-id");

        if (id) {
            MeasureEditFactory.showMeasure({
                measureId: parseInt(id),
                templateId: 0,
                parentId: 0,
                parentGuid: null,
                fullScreen: true,
                onClose: ((reason: PopupCloseType, id: number) => {
                    document.location = document.location;
                })
            });
        }
    }

    private groupByTemplateId = (groups: any, ereignisId: number, measureId: number) => {
        if (!groups.find(f => f.templateId == ereignisId)) {
            // add templateId
            groups.push({ templateId: ereignisId, measureIds: [] });

            // add measureId
            let groupTemplate = groups.find(f => f.templateId == ereignisId);
            if (!groupTemplate.measureIds.find(f => f == measureId)) {
                groups.find(f => f.templateId == ereignisId).measureIds.push(measureId);
            }
        } else {
            let groupTemplate = groups.find(f => f.templateId == ereignisId);
            if (!groupTemplate.measureIds.find(f => f == measureId)) {
                groups.find(f => f.templateId == ereignisId).measureIds.push(measureId);
            }
        }
    }

    render(): HTMLElement {
        this.getElement();

        this.renderData(this.element, this.props.measureId, this.props.viewId);

        this.props.widget.setGridPosition();

        return this.element;
    }
}
